import { useState } from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
} from '@mui/material';

import { Helmet } from 'react-helmet-async';

function ChangedPlan(
  {
    selectedPlanName,
    setChangedSuccessfully,
    setSelectedPlan,
    requestPlansList,
  }: {
    selectedPlanName: string,
    setChangedSuccessfully: (changedSuccessfully: boolean) => void,
    setSelectedPlan: (plan: any) => void,
    requestPlansList: (callback: (isLoading: boolean) => void) => Promise<void>,
  },
) {
  // variables
  const [isLoading, setIsLoading] = useState(false);

  // functions
  const handleReturn = async () => {
    setIsLoading(true);
    await requestPlansList(() => { })
      .then(() => {
        setChangedSuccessfully(false);
        setSelectedPlan(null);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  // render conditions
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          ご契約プランの変更
        </title>
      </Helmet>
      <Box className="text-center py-5 container-fluid" sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <h1 className="text-bold my-4">ご契約プランの変更</h1>
        <Box className="card">
          <Box className="card-body mt-3">
            <Grid container justifyContent="center" spacing={2}>
              <Grid item sm={12}>
                <h2>ご契約プランの変更が完了いたしました。</h2>
              </Grid>
              <Grid item sm={12}>
                <FontAwesomeIcon icon={faCircleCheck} color="green" size="6x" />
              </Grid>
              <Grid item sm={12}>
                <h1 className="text-bold">契約プラン</h1>
              </Grid>
              <Grid item sm={6} sx={{ backgroundColor: '#e2e3e5' }}>
                <h1>{selectedPlanName}</h1>
              </Grid>
            </Grid>
            <Grid item sm={6} className="text-bold mt-4">
              <p>
                お申込みいただいたプランは本日よりご利用いただけます。
                <br />
                引き続きビルドセルフをご利用ください。
              </p>
            </Grid>
            <Grid item className="mt-5">
              <Button
                variant="outlined"
                className="btn-outline-secondary"
                onClick={handleReturn}
              >
                戻る
              </Button>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ChangedPlan;
